import { useCallback, useState } from "react";
import useApi from "../../../utils/api"

export const useTimesheetImportLogs = () => { 
    const [data, setData] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);

    const { authGet, authDelete } = useApi();

    const getLogs = useCallback(async(params, controller) => {
        setLoading(true);
        try {
            const response = await authGet("/time-sheet/import/logs", {
                params,
                signal: controller?.signal
            });
            if (response) {
                setData(response.result);
                setTotalItems(response.totalItems);
            }
        } catch(err) {
        } finally {
            setLoading(false);
        }
    }, [authGet]);

    const revertImport = useCallback(async(id, onSuccess, onFailure) => {
        try {
            const response = await authDelete(`/time-sheet/import/logs/${id}`);
            onSuccess?.(id, response);
        } catch(err) {
            onFailure?.(err);
        }
    }, [authDelete]);

    return {
        getLogs,
        revertImport,
        setData,
        data,
        loading,
        totalItems
    }
}